<script>
    import { onDestroy, onMount } from "svelte";
    import { show_sidebar } from "../app-store";

    export let show = false;
    export let onToggle = () => {};    
</script>

<button 
    class="sidebar-toggle {show ? 'show' : ''}" 
    on:click={onToggle} 
    aria-label={$show_sidebar ? "Close sidebar" : "Open sidebar"}
    aria-expanded={$show_sidebar}
>
    <div class="hamburger" class:open={$show_sidebar}>
        <span></span>
        <span></span>
        <span></span>
    </div>
</button>

<style>
    .sidebar-toggle {
        display: none;
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 10px;
        align-items: center;
        justify-content: center;
    }

    .sidebar-toggle.show {
        display: flex;
    }
    
    .hamburger {
        width: 24px;
        height: 20px;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    
    .hamburger span {
        display: block;
        height: 3px;
        width: 100%;
        background-color: #5e5c5c;
        border-radius: 3px;
        transition: all 0.3s ease;
    }
    
    /* Animation for open state */
    .hamburger.open span:first-child {
        transform: translateY(8.5px) rotate(45deg);
    }
    
    .hamburger.open span:nth-child(2) {
        opacity: 0;
    }
    
    .hamburger.open span:last-child {
        transform: translateY(-8.5px) rotate(-45deg);
    }
</style>